import { createContext } from 'react';

export const RegionContext = createContext({
    regionName: 'Лобня',
    regionAlias: 'lobnya',
    loginRegion: () => {}

});